import { render, staticRenderFns } from "./ChangeName.vue?vue&type=template&id=0e5551d5&"
import script from "./ChangeName.vue?vue&type=script&lang=js&"
export * from "./ChangeName.vue?vue&type=script&lang=js&"
import style0 from "./ChangeName.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports